import React, { useEffect, useState } from 'react'
import { Box, Card, Grid, Typography } from '@material-ui/core'
import axios from 'axios'

import { useGetAssessmentsQuery } from 'hooks/useApollo'
import { useGlobalWebSocket } from 'context/WebSocketContext'
import CustomGauge from './PieChart'
import { makeStyles, useTheme } from '@material-ui/core/styles'
import UnusualActivities from './UnusualActivities'
import {
	AccessTime,
	AccessTimeOutlined,
	CheckCircleOutline,
	Close,
	Devices,
	DevicesOutlined,
	HourglassBottom,
	HourglassBottomOutlined,
	Language,
	LanguageOutlined,
	LaptopMac,
	LaptopMacOutlined,
	PlayArrow,
	Public,
	PublicOutlined
} from '@material-ui/icons'
interface TechnicalAssessmentProps {
	assessId: string
	applicantData?: any
	filterOptions?: any[] // Add this line
}

const useStyles = makeStyles(theme => ({
	oddRow: {
		backgroundColor:
			theme.palette.mode === 'dark'
				? theme.palette.background.paper
				: theme.palette.grey[100]
	}
}))
const TechnicalAssessment: React.FC<TechnicalAssessmentProps> = ({
	assessId,
	applicantData
}) => {
	const [attemptDetails, setAttemptDetails] = useState([
		{
			ipAddress: applicantData?.IPAddress,
			browser: applicantData?.browser,
			location: applicantData?.location,
			os: applicantData?.osVersion,
			starttestTime: applicantData?.startTestTime,
			endtestTime: applicantData?.endTestTime,
			totalScore: applicantData?.Score,
			assessmentName: applicantData?.AssessmentName,
			duration: applicantData?.ExamDuration,
			maxTime: applicantData?.maxTime,
			timeSpent: applicantData?.totalTimeSpent,
			progress: applicantData?.progress
		}
	])
	const classes = useStyles()
	const fetchData = async () => {
		if (!assessId) return

		try {
			const response = await axios.post<{ data: any[] }>(
				`${process.env.REACT_APP_API_URL}/api/v1/sandbox/getApplicantsbyTeam`,
				{ assessId },
				{ headers: { 'Content-Type': 'application/json' } }
			)

			const rawData = response.data?.data || []

			if (rawData.length > 0) {
				const selectedApplicantData = rawData.find(
					item => item.email === applicantData?.email
				)

				if (selectedApplicantData) {
					setAttemptDetails([
						{
							ipAddress: selectedApplicantData.IPAddress,
							browser: selectedApplicantData.browser,
							location: selectedApplicantData.location,
							os: selectedApplicantData.osVersion,
							starttestTime: selectedApplicantData.startTestTime,
							endtestTime: selectedApplicantData.endTestTime,
							totalScore: selectedApplicantData.Score,
							assessmentName: selectedApplicantData.AssessmentName,
							duration: selectedApplicantData.ExamDuration,
							maxTime: selectedApplicantData.maxTime,
							timeSpent: selectedApplicantData.totalTimeSpent,
							progress: selectedApplicantData.progress
						}
					])
				}
			}
		} catch (error) {
			console.error('Error fetching applicant details:', error)
		}
	}

	const { data, refetch } = useGetAssessmentsQuery({
		variables: { lastActive: localStorage.getItem('lastActive') }
	})

	const { registerRefetch } = useGlobalWebSocket()

	useEffect(() => {
		const unregister = registerRefetch(refetch)
		return () => unregister()
	}, [registerRefetch, refetch])

	useEffect(() => {
		fetchData()
	}, [data, assessId])

	return (
		<Box style={{ marginTop: '-20px' }}>
			<Card
				sx={{
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'flex-start',
					borderRadius: '10px'
				}}
			>
				{attemptDetails.map((detail, index) => (
					<Box key={index} sx={{ width: '100%' }}>
						<Typography variant="h6" fontWeight="bold">
							{detail.assessmentName}
						</Typography>
					</Box>
				))}

				{attemptDetails.map((detail, index) => (
					<Grid container spacing={2} sx={{ width: '100%' }} key={index}>
						<Grid item xs={12} sm={6}>
							<Card
								sx={{
									p: 2,
									borderRadius: '10px',
									boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)'
								}}
							>
								<Box display="flex" gap={1} alignItems="center">
									<AccessTimeOutlined fontSize="small" sx={{ color: 'gray' }} />
									<Box>
										<Typography variant="body2" color="textSecondary">
											Started
										</Typography>
										<Typography variant="body1" fontWeight="bold">
											{detail.starttestTime
												? `${new Date(
														detail.starttestTime
												  ).toLocaleDateString()} - ${new Date(
														detail.starttestTime
												  ).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`
												: 'Not Available'}
										</Typography>
									</Box>
								</Box>
							</Card>
						</Grid>

						<Grid item xs={12} sm={6}>
							<Card
								sx={{
									p: 2,
									borderRadius: '10px',
									boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)'
								}}
							>
								<Box display="flex" gap={1} alignItems="center">
									<CheckCircleOutline fontSize="small" sx={{ color: 'gray' }} />
									<Box>
										<Typography variant="body2" color="textSecondary">
											Completed
										</Typography>
										<Typography variant="body1" fontWeight="bold">
											{detail.endtestTime
												? `${new Date(
														detail.endtestTime
												  ).toLocaleDateString()} - ${new Date(
														detail.endtestTime
												  ).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`
												: 'Not Available'}
										</Typography>
									</Box>
								</Box>
							</Card>
						</Grid>

						{/* <Grid
							item
							xs={12}
							display="flex"
							flexDirection="column"
							alignItems="center"
							// className={classes.oddRow}
						>
							<Typography variant="h6" align="left" sx={{ width: '100%' }}>
								Score
							</Typography>
							<CustomGauge percentage={detail.totalScore} />
						</Grid> */}
						<Grid item xs={12} display="flex" flexDirection="column" alignItems="center">
							<Typography
								variant="h6"
								fontWeight="bold"
								align="left"
								sx={{ width: '100%' }}
							>
								Score
							</Typography>
							{detail.progress == 100 && detail.totalScore != null ? (
								<CustomGauge percentage={detail.totalScore} />
							) : (
								<Typography variant="body1" color="textSecondary">
									No score populated
								</Typography>
							)}
						</Grid>
					</Grid>
				))}

				<Card sx={{ borderRadius: '10px', width: '100%' }}>
					<Typography variant="h6" fontWeight="bold">
						Attempt Details
					</Typography>
					{attemptDetails.map((detail, index) => (
						<Grid container spacing={3} key={index}>
							<Grid item xs={12} sm={4}>
								<Box
									bgcolor="rgba(241, 241, 255, 0.3)"
									p={2}
									borderRadius={2}
									mb={2}
									height="76px"
								>
									<Box display="flex" alignItems="center" gap={1}>
										<LanguageOutlined sx={{ fontSize: 16 }} />
										<Typography variant="body2" color="textSecondary">
											IP Address
										</Typography>
									</Box>
									<Typography variant="body1" fontWeight="bold">
										{detail.ipAddress || '-'}
									</Typography>
								</Box>

								<Box
									bgcolor="rgba(241, 241, 255, 0.3)"
									p={2}
									borderRadius={2}
									height="76px"
								>
									<Box display="flex" alignItems="center" gap={1}>
										<DevicesOutlined sx={{ fontSize: 16 }} />
										<Typography variant="body2" color="textSecondary">
											Browser
										</Typography>
									</Box>
									<Typography variant="body1" fontWeight="bold">
										{detail.browser || '-'}
									</Typography>
								</Box>
							</Grid>

							<Grid item xs={12} sm={4}>
								<Box
									bgcolor="rgba(241, 241, 255, 0.3)"
									p={2}
									borderRadius={2}
									mb={2}
									height="76px"
								>
									<Box display="flex" alignItems="center" gap={1}>
										<PublicOutlined sx={{ fontSize: 16 }} />
										<Typography variant="body2" color="textSecondary">
											Location
										</Typography>
									</Box>
									<Typography variant="body1" fontWeight="bold">
										{detail.location || '-'}
									</Typography>
								</Box>

								<Box
									bgcolor="rgba(241, 241, 255, 0.3)"
									p={2}
									borderRadius={2}
									height="76px"
								>
									<Box display="flex" alignItems="center" gap={1}>
										<LaptopMacOutlined sx={{ fontSize: 16 }} />
										<Typography variant="body2" color="textSecondary">
											Operating System
										</Typography>
									</Box>
									<Typography variant="body1" fontWeight="bold">
										{detail.os || '-'}
									</Typography>
								</Box>
							</Grid>

							<Grid item xs={12} sm={4}>
								<Box
									bgcolor="rgba(241, 241, 255, 0.3)"
									p={2}
									borderRadius={2}
									mb={2}
									height="76px"
								>
									<Box display="flex" alignItems="center" gap={1}>
										<AccessTimeOutlined sx={{ fontSize: 16 }} />
										<Typography variant="body2" color="textSecondary">
											Duration
										</Typography>
									</Box>
									<Typography variant="body1" fontWeight="bold">
										{detail.duration || '-'}
									</Typography>
								</Box>

								<Box
									bgcolor="rgba(241, 241, 255, 0.3)"
									p={2}
									borderRadius={2}
									height="76px"
								>
									<Box display="flex" alignItems="center" gap={1}>
										<HourglassBottomOutlined sx={{ fontSize: 16 }} />

										<Typography variant="body2" color="textSecondary">
											Time Taken
										</Typography>
									</Box>
									<Typography variant="body1" fontWeight="bold">
										{detail.timeSpent || '-'}
									</Typography>
								</Box>
							</Grid>
						</Grid>
					))}
				</Card>
			</Card>
			<UnusualActivities assessId={assessId} uuid={applicantData?.uuid} />
		</Box>
	)
}

export default TechnicalAssessment
